import { render, staticRenderFns } from "./CacheManagement.vue?vue&type=template&id=c3552708&scoped=true&"
import script from "./CacheManagement.vue?vue&type=script&lang=js&"
export * from "./CacheManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3552708",
  null
  
)

export default component.exports